import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { VStack } from "IZOX/_X";
import { ImCross } from "react-icons/im";
import _ from "lodash";

/**
 * @augments {Component<Props, State>}
 */
class ZBackdrop extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      closeHover: false
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ZBackdrop.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setCloseHover = (tf) => {
    this.setState({
      closeHover: tf
    });
  }

  render(){
    let {content} = this.props;
    let {closeHover} = this.state;
    let {render, addOns, closeButton, onClose} = content;
    return (
      <VStack fullWidth fullHeight VAlign="-">
        {_.isFunction(render) && render(addOns)}
        {closeButton &&
          <div onClick={(e) => {
              e.stopPropagation();
              onClose?.();
              GFunc.CloseBackdrop();
            }} 
            onMouseEnter={() => this._setCloseHover(true)}
            onMouseLeave={() => this._setCloseHover(false)}
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              cursor: "pointer",
              width: 40,
              height: 40,
              backgroundColor: ColorX.CSS("pureDark", closeHover? 0.8 : 0.5),
              borderRadius: "0 0 0 40px"
            }}>
            <ImCross color={ColorX.CSS("pureWhite")}
              style={{
                position: "absolute",
                left: 18,
                top: 8
              }}/>
          </div>
        }
      </VStack>
    );
  }

}

export default observer(ZBackdrop);
